import { Colors } from "../constants/colors";

export default {
  styleOverrides: {
    root: {
      "& .Mui-selected": {
        backgroundColor: `${Colors.BLUE400} !important`,
      },
    },
  },
};
